import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecentActivity } from '../hooks/useRecentActivity';

function buildRouteView(pathname: string, search: string) {
	const fullPath = `${pathname}${search || ''}`;

	// Order, invoice, and rekey detail pages track themselves with proper labels
	// (RO#, VIN, invoice number) so we skip them here to avoid duplicates
	if (pathname.startsWith('/order/')) {
		return null;
	}
	if (pathname.startsWith('/invoices/') && pathname !== '/invoices') {
		return null;
	}
	if (pathname.startsWith('/rekey/') && pathname !== '/rekey') {
		return null;
	}
	if (pathname === '/invoices') {
		return {
			type: 'route' as const,
			key: `route:${pathname}`,
			label: 'Parts Invoicing',
			path: fullPath,
		};
	}
	if (pathname === '/rekey') {
		return {
			type: 'route' as const,
			key: `route:${pathname}`,
			label: 'ReKey Feed',
			path: fullPath,
		};
	}
	if (pathname === '/dashboard') {
		return {
			type: 'route' as const,
			key: `route:${pathname}`,
			label: 'Dashboard',
			path: fullPath,
		};
	}
	if (pathname === '/todo') {
		return {
			type: 'route' as const,
			key: `route:${pathname}`,
			label: 'To Do',
			path: fullPath,
		};
	}
	if (pathname === '/') {
		return {
			type: 'route' as const,
			key: `route:${pathname}`,
			label: 'Activity',
			path: fullPath,
		};
	}
	// Default: only track known app pages, skip errors/login/etc.
	return null;
}

const RecentActivityTracker = () => {
	const { trackView } = useRecentActivity();
	const location = useLocation();

	const view = useMemo(
		() => buildRouteView(location.pathname, location.search),
		[location.pathname, location.search]
	);

	useEffect(() => {
		if (!view) return;
		trackView(view);
	}, [trackView, view]);

	return null;
};

export default RecentActivityTracker;


